import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface DismissalsState {
  persistentDismissedIds: string[]; // Persisted to localStorage via redux-persist
  sessionDismissedIds: string[]; // Memory only - resets on page refresh
}

const initialState: DismissalsState = {
  persistentDismissedIds: [], // Rehydrated automatically by redux-persist
  sessionDismissedIds: [],
};

export const dismissalsSlice = createSlice({
  name: 'systemNotifications/dismissals',
  initialState,
  reducers: {
    dismissNotification: (state, action: PayloadAction<{ id: string; persistent: boolean }>) => {
      const { id, persistent } = action.payload;
      if (persistent) {
        // Persistent: redux-persist auto-saves to localStorage
        if (!state.persistentDismissedIds.includes(id)) {
          state.persistentDismissedIds.push(id);
        }
      } else {
        // Session-only: memory only, cleared on refresh
        if (!state.sessionDismissedIds.includes(id)) {
          state.sessionDismissedIds.push(id);
        }
      }
    },
  },
});

export const { dismissNotification } = dismissalsSlice.actions;
export default dismissalsSlice.reducer;
